import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import brandTheme from '../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

const styles = {
  container: {
    backgroundColor: 'white',
    height: 30,
    lineHeight: '30px',
    '&:hover': {
      backgroundColor: '#F8F8F8',
    },
    paddingLeft: 30,
  },
  containerActive: {
    //backgroundColor: '#F8F8F8',
    color: colors.secondary,
  },
  iconContainer: {
    height: 30,
    width: 30,
    display: 'inline-block',
    textAlign: 'center',
    lineHeight: '30px',
    '&>*': {
      verticalAlign: 'middle',
    },
    float: 'right',
    fill: '#8A96A0',
  },
  content: {
    display: 'inline-block',
  },
}

const SmallOption = ({ children, active, classes, icon, ...otherProps }) => (
  <div
    className={classNames({
      [classes.container]: true,
      [classes.containerActive]: active,
    })}
    {...otherProps}
  >
    <div className={classes.content}>{children}</div>
    <div className={classes.iconContainer}>{icon}</div>
  </div>
)

export default injectStyles(styles)(SmallOption)



// WEBPACK FOOTER //
// ./src/Components/DashboardSidebar/SmallOption.js